import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { map, includes } from 'lodash';

import './styles.css';

const SubNavigation = props => {
  const SubNavigationList = [
    'Appreciate',
    'Acknowledge',
    'Share',
    'Explain',
    'Follow Up'
  ];
  const { activeList, currentHeading } = props;
  const renderList = map(SubNavigationList, item => {
    if (includes(activeList, item)) {
      if (includes(currentHeading, item)) {
        return (
          <li key={item} className="font-weight-bold active">
            {item}
          </li>
        );
      }

      return (
        <li key={item} className="font-weight-bold active" style={{color: '#B0B0B0'}}>
          {item}
        </li>
      );
    }

    return (
      <li key={item} style={{ visibility: 'hidden' }}>
        {item}
      </li>
    );
  });

  return (
    <Row>
      <Col xs={12}>
        <ul className="sub-navi">{renderList}</ul>
      </Col>
    </Row>
  );
};

export default SubNavigation;



// WEBPACK FOOTER //
// ./src/components/SubNavigation/index.jsx